import { CreateAccountValues } from "../../types";

export const createInitialState = (email?: string): CreateAccountValues => ({
  email: email ?? "",
  firstname: "",
  lastname: "",
  password: ""
});
